import React, { useState, useEffect } from 'react';
import { FiChevronRight, FiVideo, FiBook, FiFileText, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import axios from 'axios';
import './Classes.css';

// Your custom alert function (make sure to add the CSS for these alerts)
const showAlert = (type, message) => {
  const alertDiv = document.createElement('div');
  
  let alertContent = '';
  if (type === 'expired') {
    alertContent = `
      <div class="student-dashboard-alert-content">
        <div class="student-dashboard-alert-icon">
          <svg viewBox="0 0 512 512" width="40" height="40">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"/>
          </svg>
        </div>
        <h3>Class Has Ended</h3>
        <p>${message}</p>
        <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
      </div>`;
  } else if (type === 'early') {
    alertContent = `
      <div class="student-dashboard-alert-content">
        <div class="student-dashboard-alert-icon">
          <svg viewBox="0 0 512 512" width="40" height="40">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
          </svg>
        </div>
        <h3>Class Not Available Yet</h3>
        <p>${message}</p>
        <p><strong>Session Duration:</strong> 50 to 60 minutes</p>
        <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
      </div>`;
  } else if (type === 'issue') {
    alertContent = `
    <div class="student-dashboard-alert-content">
      <div class="student-dashboard-alert-icon">
        <svg viewBox="0 0 512 512" width="40" height="40">
          <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
        </svg>
      </div>
      <h3>Issue Report</h3>
      <p>${message}</p>
      <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
    </div>`;
  } else {
    alertContent = `
      <div class="student-dashboard-alert-content">
        <div class="student-dashboard-alert-icon">
          <svg viewBox="0 0 512 512" width="40" height="40">
            <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
          </svg>
        </div>
        <h3>Teacher Class Notes</h3>
        <p>${message}</p>
        <button class="student-dashboard-alert-button" onclick="this.parentElement.parentElement.remove()">OK</button>
      </div>`;
  }

  alertDiv.className = `student-dashboard-custom-alert student-dashboard-${type}-alert`;
  alertDiv.innerHTML = alertContent;
  document.body.appendChild(alertDiv);
};

const Classes = ({ day, userData }) => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedClass, setExpandedClass] = useState(null);
  const [joiningClassId, setJoiningClassId] = useState(null); // Track which class is being joined
  const [reportingClassId, setReportingClassId] = useState(null); // Track which class has a report being submitted
  const [reportingIssue, setReportingIssue] = useState({ classId: null, issueType: null });

  useEffect(() => {
    fetchClasses();
    
    const intervalId = setInterval(() => {
      fetchClasses();
    }, 60000); // 60,000 ms = 1 minute
  
    // Clean up the interval on unmount
    return () => clearInterval(intervalId);
  }, [day, userData.id]);

  const fetchClasses = async () => {
    try {
      const formattedDay = (() => {
        const today = new Date();
        const lowercaseDay = day.toLowerCase();
        
        if (lowercaseDay === 'today') {
          // Add 3 hours to current date
          today.setHours(today.getHours() + 3);
          console.log(lowercaseDay,today.toISOString().split('T')[0]);
          return today.toISOString().split('T')[0];
        } else if (lowercaseDay === 'tomorrow') {
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          tomorrow.setHours(today.getHours() + 3); // Also add 3 hours for consistency
          console.log(lowercaseDay,tomorrow.toISOString().split('T')[0]);
          return tomorrow.toISOString().split('T')[0];
        } else if (lowercaseDay === 'yesterday') {
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          yesterday.setHours(today.getHours() + 3); // Also add 3 hours for consistency
          console.log(lowercaseDay,yesterday.toISOString().split('T')[0]);
          return yesterday.toISOString().split('T')[0];
          
        } else {
          return day; // assume it's already in YYYY-MM-DD format
        }
      })();
      
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/teacher/classes/${userData.id}/${formattedDay}`;
      const response = await axios.get(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      const formattedClasses = response.data.myClasses.map(cls => ({
        id: cls.Id,
        type: cls.Type === 0 ? 'paid' : 'demo',
        IdUser: cls.IdUser,
        studentImage: cls.image || "",
        studentName: `${cls.FirstName} ${cls.LastName}`,
        classesTaken: `${cls.sessionsTaken}/${cls.totalSessions}`,
        level: cls.IdGradesPlans === 2 ? 'Junior' : cls.IdGradesPlans === 1 ? 'Little' : 'Group',
        classType: cls.Type === 0 ? 'Paid Class' : 'Demo Class',
        hasPTM: cls.sessionsTaken===cls.totalSessions? true: false,
        hasFinish: cls.sessionsTaken>cls.totalSessions? true: false,

        prevProject: cls.lastCourse?.CourseName || 'No previous project',
        nextProject: cls.nextCourse?.CourseName || 'No next project',
        course: cls.nextCourse?.CourseName || 'No course',
        time: new Date(cls.ClassDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        date: new Date(cls.ClassDateTime).toLocaleDateString([], { day: '2-digit', month: 'short' , year: 'numeric' }),
        classDateTime: new Date(cls.ClassDateTime),
        courseNotes: cls.coursenotes,
        lastCourseLink: cls.lastCourse?.CourseLink,
        nextCourseLink: cls.nextCourse?.CourseLink,
        projectLink: cls.lastCourse?.CourseProjectLink,
        nextprojectLink: cls.nextCourse?.CourseProjectLink,
        Issue: cls.Issue || null // Added issue field
      }));

      setClasses(formattedClasses);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleViewNotes = (notes) => {
    if (notes && notes.trim() !== '') {
      showAlert('info', notes);
    } else {
      showAlert('info', 'No notes available for this class.');
    }
  };

  const handleJoinClass = async (classId) => {
    try {
      setJoiningClassId(classId); // Set loading state

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/classes/check-availability`, {
        classId
      });
  
      const { status, message, zoomUrl } = response.data;
  
      if (status === 'expired') {
        showAlert('expired', message);
        setJoiningClassId(null);

        return;
      }
  
      if (status === 'early') {
        showAlert('early', message);
        setJoiningClassId(null);

        return;
      }
  
      if (status === 'joining') {
        const joinResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/classes/confirm-join/teacherjoin`, {
          classId
        });
  
        if (joinResponse.data.success) {
          window.open(zoomUrl, '_blank');
        } else {
          showAlert('error', 'Failed to join class. Please try again.');
        }
      }
    } catch (error) {
      console.error('Error:', error);
      showAlert('error', 'An error occurred. Please try again.');
    } finally {
      setJoiningClassId(null); // Reset loading state
    }
  };

  const toggleExpand = (id) => {
    setExpandedClass(expandedClass === id ? null : id);
  };

  const isReportSectionActive = (classDateTime) => {
    const now = new Date();
    const classEndTime = new Date(classDateTime);
    classEndTime.setHours(classEndTime.getHours() + 1); // Add 1 hour to class time
    
    return now >= classDateTime && now <= classEndTime;
  };


  const isReporting = (classId, issueType) => {
    return reportingIssue.classId === classId && reportingIssue.issueType === issueType;
  };


  const handleSubmitIssue = async (classId, issueType) => {
  
    try {
      setReportingIssue({ classId, issueType }); // Set which specific button is loading

      const submissionData = {
        IdSchedule: classId,
        IdIssue: issueType
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/teacher/submitissue`,
        submissionData
      );
  
      if (response.status === 200) {
        showAlert('issue', 'Report Submitted');
        await fetchClasses();
      } else {
        showAlert('issue', 'Failed to submit issue. Please try again.');
      }
  
    } catch (error) {
      console.error('Error submitting issue:', error);
      showAlert('issue', 'An error occurred while submitting the issue.');
    }finally {
      setReportingIssue({ classId: null, issueType: null }); // Reset loading state
    }
  };
  if (loading) {
    return (
      <div className="pending-loading">
        <div className="spinner"></div>
        <p>Loading Your Classes...</p>
      </div>
    );
  }

  if (error) {
    return <div className="classes-container">Error: {error}</div>;
  }

  
  
  return (
    <div className="classes-container">

      {classes.length === 0 ? (
        <div className="no-classes">No classes scheduled for this day</div>
      ) : (
        <div className="classes-list">
          {classes.map((cls) => (
              <div 
                key={cls.id} 
                className={`class-card ${cls.type} ${expandedClass === cls.id ? 'expanded' : ''}`}
                onMouseEnter={() => toggleExpand(cls.id)}
                onMouseLeave={() => setExpandedClass(null)}
              >
              <div className="class-main-info">
                <div className="student-info">
                  <img src={cls.studentImage} alt={cls.studentName} className="student-avatar shadow" />
                  <div className="student-details">
                    <h4 className="student-name">{cls.studentName}{" "} 
                    {cls.type === "paid" && (
                    <a 
                      href={`/studentprofile/${cls.IdUser}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="student-profile-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <svg 
                        viewBox="0 0 24 24" 
                        width="18" 
                        height="18" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </a>
                  )}
                  </h4>
                    <div className={`classes-taken ${cls.hasPTM ? 'text-red' : ''}`}>
                      {cls.type === "demo" ? "" : cls.hasFinish ? 'Awaiting Updates' : `Class Nb: ${cls.classesTaken}`}
                    </div>                    
                    <div className="badges-container">
                      <span className={`badge level ${cls.level.toLowerCase()}`}>{cls.level}</span>
                      <span className={`badge type ${cls.type}`}>{cls.classType}</span>
                      {cls.hasPTM && cls.type === "paid" && <span className="badge ptm">PTM</span>}
                    </div>
                  </div>
                </div>
                
               
                
                <div className="class-time">
                <div> {cls.time}</div><div>{cls.date}</div>
                 
               
                  
                </div>
              </div>
              <div className="projects-container">
              {cls.type === "paid"?(
                <>
                  <div className="project-section">
                    <div className="project-label">Prev Project:
                    <span className="project-title"> {cls.prevProject}</span></div>
                    <div className="project-buttons">
                      {cls.lastCourseLink && (
                        <a href={cls.lastCourseLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                          <FiVideo /> Project
                        </a>
                      )}
                      {cls.projectLink && (
                        <a href={cls.projectLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                         <FiBook /> Course
                        </a>
                      )}
                      
                      {cls.lastCourseLink && cls.courseNotes && (
                        <button 
                          className="project-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewNotes(cls.courseNotes);
                          }}
                        >
                          <FiFileText /> Note
                        </button>
                      )}
                    </div>
                  </div>
                  
                  <div className="project-section">
                    <div className="project-label">Next Project:
                    <span className="project-title"> {cls.nextProject}</span></div>
                    <div className="project-buttons">
                      {cls.nextCourseLink && (
                        <a href={cls.nextCourseLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                          <FiVideo /> Project
                        </a>
                      )}
                      {cls.nextprojectLink && (
                        <a href={cls.nextprojectLink} target="_blank" rel="noopener noreferrer" className="project-btn">
                         <FiBook /> Course
                        </a>
                      )}
                    </div>
                  </div>
                  </>
                  ):(
                    <>
                     <div className="project-section">
                    <div className="project-label">Projects:
                    <span className="project-title"> Demo Projects</span></div>
                    <div className="project-buttons">
                      
                      
                    </div>
                   
                  </div>
                  
                  <div className="project-section">
                    
                  </div>
                    </>

                  )}
                  <div className="project-section class-time">
                  <button 
                    className="join-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleJoinClass(cls.id);
                    }}
                    disabled={joiningClassId === cls.id}
                  >
                    {joiningClassId === cls.id ? (
                      <>
                        <span className="spinner"></span> Joining...
                      </>
                    ) : (
                      <>Join Class <FiChevronRight /></>
                    )}
                  </button>
                  </div>
                </div>




                <div className={`report-section ${expandedClass === cls.id ? 'open' : ''}`}>
                <div className="report-title">Report Issue:</div>
                <div className="report-buttons">
                  <button 
                    className={`report-btn ${cls.Issue === 1 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 1)}
                    disabled={!isReportSectionActive(cls.classDateTime) || isReporting(cls.id, 1)}
                  >
                    {isReporting(cls.id, 1) ? (
                      <>
                      <span className="spinner small"></span> <FiAlertCircle /> Student Not Joined
                     </>
                    ) : (
                      <>
                        <FiAlertCircle /> Student Not Joined
                      </>
                    )}
                  </button>

                  <button 
                    className={`report-btn ${cls.Issue === 2 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 2)}
                    disabled={!isReportSectionActive(cls.classDateTime) || isReporting(cls.id, 2)}
                  >
                    {isReporting(cls.id, 2) ? (
                      <>
                      <span className="spinner small"></span> <FiAlertCircle /> Student Left
                     </>
                    ) : (
                      <>
                        <FiAlertCircle /> Student Left
                      </>
                    )}
                  </button>        

                  <button 
                    className={`report-btn ${cls.Issue === 3 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 3)}
                    disabled={!isReportSectionActive(cls.classDateTime) || isReporting(cls.id, 3)}
                  >
                    {isReporting(cls.id, 3) ? (
                      <>
                      <span className="spinner small"></span> <FiAlertCircle /> Internet Issue
                     </>
                    ) : (
                      <>
                        <FiAlertCircle /> Internet Issue
                      </>
                    )}
                  </button>  
                  
                  <button 
                    className={`report-btn ${cls.Issue === 4 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 4)}
                    disabled={!isReportSectionActive(cls.classDateTime) || isReporting(cls.id, 4)}
                  >
                    {isReporting(cls.id, 4) ? (
                      <>
                      <span className="spinner small"></span> <FiAlertCircle /> Mic/Audio Issue
                     </>
                    ) : (
                      <>
                        <FiAlertCircle /> Mic/Audio Issue
                      </>
                    )}
                  </button>

                  <button 
                    className={`report-btn ${cls.Issue === 5 ? 'activered' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 5)}
                    disabled={!isReportSectionActive(cls.classDateTime) || isReporting(cls.id, 5)}
                  >
                    {isReporting(cls.id, 5) ? (
                      <>
                       <span className="spinner small"></span> <FiAlertCircle /> Zoom Link Issue
                      </>
                    ) : (
                      <>
                        <FiAlertCircle /> Zoom Link Issue
                      </>
                    )}
                  </button>

                  <button 
                    className={`report-btn resolved ${cls.Issue === 0 ? 'resolvedyes' : ''}`}
                    onClick={() => handleSubmitIssue(cls.id, 0)}
                    disabled={!isReportSectionActive(cls.classDateTime) || isReporting(cls.id, 0)}
                  >
                    {isReporting(cls.id, 0) ? (
                      <>
                        <span className="spinner small"></span> <FiCheckCircle /> Issue Resolved
                      </>
                      
                    ) : (
                      <>
                        <FiCheckCircle /> Issue Resolved
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Classes;